module.exports = __webpack_public_path__ + "static/media/manufacturing-macrovector_oficial-01 7.a28390da.png";